export const setCookie = (name: string, value: string, time: number) => {
    const exdate = new Date()
    exdate.setDate(exdate.getDate() + time);
    document.cookie = name + '=' + encodeURIComponent(value) + (time == null ? '' : ';expires=' + exdate.toISOString())
}
export const getCookie = (name: string) => {
    const c = document.cookie.split(';')
    const cname = name + '='
    for(let i = 0; i< c.length; i++){
        const ca = c[i].trim()
        if(ca.indexOf(cname) == 0) return decodeURIComponent(ca.substring(cname.length,ca.length))
    }
    return ''
}
export const deleteCookie = (name: string,path:string='/') => {
    const date = new Date()
    date.setTime(date.getTime() -1*24*60*60*1000)
    document.cookie = name + "=' ';expires=" + date.toISOString() + ';path=' + path
}
export const checkCookie = (name: string) => {
    const c = getCookie(name)
    return c == '' || !c ? false : true
}